var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-block",class:['btn-' + _vm.type, _vm.small?'':'btn-lg'],attrs:{"disabled":_vm.disabled},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":function($event){return _vm.$emit('click', $event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }